<script>
	export let layout;
	//	hairlines on half pixels stay 1px crisp
	const px = (v) => Math.round(v) + 0.5;
	$: plot = layout.plot;
</script>

<g class="grid">
	{#each layout.grid as t}
		{#if layout.horizontal}
			<line x1={px(t.pos)} x2={px(t.pos)} y1={plot.y} y2={plot.y + plot.h} class:zero={t.zero} />
		{:else}
			<line x1={plot.x} x2={plot.x + plot.w} y1={px(t.pos)} y2={px(t.pos)} class:zero={t.zero} />
		{/if}
	{/each}
	{#if !layout.zeroIn}
		{#if layout.horizontal}
			<line class="baseline" x1={px(layout.basePos)} x2={px(layout.basePos)} y1={plot.y} y2={plot.y + plot.h} />
		{:else}
			<line class="baseline" x1={plot.x} x2={plot.x + plot.w} y1={px(layout.basePos)} y2={px(layout.basePos)} />
		{/if}
	{/if}
</g>

<g class="ticks">
	{#each layout.grid as t}
		{#if layout.horizontal}
			<text x={t.pos} y={plot.y + plot.h + 16} text-anchor="middle">{t.label}</text>
		{:else}
			<text x={plot.x - 6} y={t.pos} text-anchor="end" dominant-baseline="middle">{t.label}</text>
		{/if}
	{/each}
</g>

<g class="cats">
	{#each layout.labels as l}
		{#if layout.horizontal}
			<text x={plot.x - 6} y={l.pos} text-anchor="end" dominant-baseline="middle">{l.text}<title>{l.full || l.text}</title></text>
		{:else}
			<text x={l.pos} y={plot.y + plot.h + 16} text-anchor={l.anchor || "middle"}>{l.text}<title>{l.full || l.text}</title></text>
		{/if}
	{/each}
</g>

{#if layout.unit}
	<text class="unit" x={layout.horizontal ? plot.x + plot.w : 0} y={plot.y - 12} text-anchor={layout.horizontal ? "end" : "start"}>{layout.unit}</text>
{/if}

<style>
	.grid line {
		stroke: var(--_grid);
		stroke-width: 1;
		shape-rendering: crispEdges;
	}

	.grid line.zero,
	.grid line.baseline {
		stroke: var(--_axis);
	}

	text {
		fill: var(--_ink-muted);
		font-size: 12px;
	}

	.ticks text,
	.unit {
		font-variant-numeric: tabular-nums;
		font-family: var(--_num-font);
	}

	.unit {
		font-size: 11px;
	}
</style>
